import {
    type CrmListId,
    type CrmListParams,
    type ListParams,
    ListVariant,
    type StaticListId,
    type StaticListParams,
} from "../types/list";

export const isStaticList = (params: ListParams): params is StaticListParams => params.variant === ListVariant.Static;

export const isCrmList = (params: ListParams): params is CrmListParams => params.variant === ListVariant.Crm;

type ListVariantMatchers<T> = {
    [ListVariant.Static]: (id: StaticListId) => T;
    [ListVariant.Crm]: (id: CrmListId) => T;
};

export const matchListVariant = <T>(params: ListParams, matchers: ListVariantMatchers<T>): T => {
    switch (params.variant) {
        case ListVariant.Static:
            return matchers[ListVariant.Static](params.id);
        case ListVariant.Crm:
            return matchers[ListVariant.Crm](params.id);
    }
};
